import styles from './AvailabilityCard.module.scss';
import { Card, FontAwesomeProIcon, Heading } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const AvailabilityCard = ({
  icon = null,
  iconSize = '2x',
  title = null,
  children = null,
}) => {
  return (
    <div>
      <Card className={styles.container}>
        <div className={styles.disclosure}>
          <div className={styles.headingGroup}>
            {icon && (
              <FontAwesomeProIcon
                className={styles.icon}
                icon={icon}
                size={iconSize}
              />
            )}
            <Heading noSpacing size="h6" theme="neutral">
              {title}
            </Heading>
          </div>
        </div>
        <div className={styles.content}>{children}</div>
      </Card>
    </div>
  );
};

AvailabilityCard.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default AvailabilityCard;
